import { format } from "date-fns";
import { Link } from "react-router-dom";
import { MultiSectionBatch } from "../useMultiSectionBatchesDetail";

type Props = {
  batch: MultiSectionBatch;
  fromRegistration: boolean;
};

const Success = ({
  endedAt,
  fromRegistration,
}: {
  endedAt: string | null;
  fromRegistration: boolean;
}) => (
  <div className="flex flex-col gap-8 rounded-lg bg-gray-100 px-10 py-[22px]">
    <div className="flex flex-col gap-8">
      <p className="text-blue-400">
        デジタル教材を登録しました
        {!fromRegistration && endedAt && (
          <span>（{format(new Date(endedAt), "yyyy/MM/dd HH:mm")}）</span>
        )}
      </p>
      <p>登録したデジタル教材は登録一覧から確認できます。</p>
      <span>
        <Link
          to="/multi_section_batches/upload_drill/list"
          className="buiButtonBase buiButtonVariantOutline buiButtonSizeSm buiButtonRound"
        >
          登録一覧を見る
        </Link>
      </span>
    </div>
  </div>
);

const Failure = ({
  feedback,
  fromRegistration,
}: {
  feedback: string | null;
  fromRegistration: boolean;
}) => (
  <div className="flex flex-col gap-8 rounded-lg bg-gray-100 px-10 py-9">
    <div className="flex flex-col gap-8">
      <p className="font-bold text-red-400">デジタル教材の登録に失敗しました</p>
      {feedback && (
        <div className="text-red-400">
          {feedback
            .split("\n")
            .filter((line) => line.trim() !== "")
            .map((line, index) => (
              <p key={index}>{line}</p>
            ))}
        </div>
      )}
      <p className="text-red-400">データを確認して再度登録を行ってください。</p>
    </div>
    {fromRegistration && (
      <span>
        <Link
          to="/multi_section_batches/upload_drill"
          className="buiButtonBase buiButtonVariantOutline buiButtonSizeSm buiButtonRound"
        >
          登録画面に戻る
        </Link>
      </span>
    )}
  </div>
);

const Pending = () => (
  <div className="flex flex-col gap-8 rounded-lg bg-gray-100 px-10 py-[22px]">
    <div className="flex flex-col gap-4">
      <p className="font-bold">デジタル教材を登録中です。</p>
      <p>処理が完了すると、校舎横断操作の完了メールをお送りします。</p>
      <p>メール内のリンクから、登録したデジタル教材をご確認いただけます。</p>
      <p>※件数が多い場合、完了までに時間がかかることがあります。</p>
    </div>
    <span>
      <button
        type="button"
        className="buiButtonBase buiButtonVariantOutline buiButtonSizeSm buiButtonRound"
        onClick={() => window.location.reload()}
      >
        再読み込み
      </button>
    </span>
  </div>
);

const renderStatus = (batch: MultiSectionBatch, fromRegistration: boolean) => {
  switch (batch.status) {
    case "standby":
    case "processing":
      return <Pending />;
    case "success":
      return (
        <Success endedAt={batch.endedAt} fromRegistration={fromRegistration} />
      );
    case "failure":
      return (
        <Failure
          feedback={batch.feedback ?? null}
          fromRegistration={fromRegistration}
        />
      );
  }
};

export const UploadDrillDetail = ({ batch, fromRegistration }: Props) => {
  return (
    <div className="flex flex-col gap-10">
      {renderStatus(batch, fromRegistration)}
    </div>
  );
};
